<template>
  <div class="room-info-page">
    <!-- Room Description Section -->
    <div class="room-description">
      <div
        class="room-card"
        :class="{ visible: room.isVisible }"
        v-for="(room, index) in rooms"
        :key="index"
        :ref="(el) => setRoomCardRef(el, index)"
      >
        <!-- 圖片區域 -->
        <div class="room-image">
          <img
            :src="require(`@/assets/picture/${room.image}`)"
            :alt="room.title"
          />
        </div>

        <!-- 文字區域 -->
        <div class="room-text">
          <h3>{{ room.title }}</h3>
          <p>{{ room.description }}</p>
          <!-- 跳轉到 RoomDetail 頁面 -->
          <button class="learn-more-btn" @click="goToRoomDetail(room.route)">
            了解更多
          </button>
        </div>
      </div>
    </div>

    <!-- Room Price Table -->
    <div class="room-pricing">
      <h2 class="room-title">房價表格</h2>
      <table>
        <thead>
          <tr>
            <th>房型</th>
            <th>坪數</th>
            <th>人數</th>
            <th>定價</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(pricing, index) in pricingData" :key="index">
            <td>{{ pricing.type }}</td>
            <td>{{ pricing.size }}</td>
            <td>{{ pricing.beds }}</td>
            <td>{{ pricing.price }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Booking Notice -->
    <div class="booking-notice">
      <h2 class="notice-title">湯屋須知</h2>
      <ul>
        <li v-for="(notice, index) in bookingNotices" :key="index">
          {{ notice }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import roomLogic from "@/assets/js/spa.js"; // 引用外部邏輯

export default {
  name: "SpaPage",
  mixins: [roomLogic], // 混入邏輯
};
</script>

<style src="@/assets/css/spa.css" scoped></style>
